import { Pipe, PipeTransform } from '@angular/core';
import { Service } from '../../models/service';

@Pipe({
	name: 'filterServiceByName'
})
export class FilterServiceByNamePipe implements PipeTransform {
	transform(service: Service[], filter: string): Service[] {
		if (
			!service ||
			!filter ||
			service === null ||
			filter === null ||
			filter === ''
		) {
			return service;
		}

		return service.filter((service: Service) => {
			if (service.name) {
				// TODO: add lastName too
				return service.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
